import {
  GET_ORDERS,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAIL,
  GET_ORDER,
  GET_ORDER_SUCCESS,
  GET_ORDER_FAIL,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAIL,
  ORDER_CONFIRMATION,
  ORDER_CONFIRMATION_SUCCESS,
  ORDER_CONFIRMATION_FAIL,
} from "./actionTypes"

// Get all orders
export const getOrders = (params, history) => ({
  type: GET_ORDERS,
  payload: { params, history },
})

// Get order details by ID
export const getOrder = (orderId, history) => ({
  type: GET_ORDER,
  payload: { orderId, history },
})

// Update order status
export const updateOrderStatus = (orderId, statusData, history) => ({
  type: UPDATE_ORDER_STATUS,
  payload: { orderId, statusData, history },
})

// Order confirmation
export const orderConfirmation = (orderId, confirmationData, history) => ({
  type: ORDER_CONFIRMATION,
  payload: { orderId, confirmationData, history },
})
